import { render, staticRenderFns } from "./MappingItem.vue?vue&type=template&id=3b4181cb"
import script from "./MappingItem.vue?vue&type=script&lang=js"
export * from "./MappingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports